import { render } from "./TownView.vue?vue&type=template&id=d9ba5e48"
import script from "./TownView.vue?vue&type=script&lang=js"
export * from "./TownView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__